import Handler from '../../commonTypes/handler.types';
import DefaultProps from '../../commonTypes/defaultprops.types';

// Types of Button Color Types
export enum ButtonStyles {
  DEFAULT = 'default',
  LINK_BLUE = 'link-blue',
  TICKET_LINK_GREEN = 'ticket-link-green',
  MLB_TV_ORANGE = 'mlb-tv-orange',
  TEAM = 'team',
  SELECTED_TAB = 'selected-tab',
}

// Types of Button Styles
export enum ButtonShapes {
  SOLID = 'solid',
  HOLLOW = 'hollow',
  HOLLOW_BORDERLESS = 'hollow-borderless',
  PILL = 'pill',
  TAB = 'tab',
}

// Button Sizes
export enum ButtonSizes {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  XLARGE = 'xl'
}

// Button Types
export enum ButtonTypes {
  BUTTON = 'button',
  RESET = 'reset',
  SUBMIT = 'submit'
}

// All the props for the Button Component
export interface ButtonProps extends DefaultProps {
  label?: string;
  type?: ButtonTypes;
  shape?: ButtonShapes;
  styleName?: ButtonStyles;
  handlers?: Handler;
  size?: ButtonSizes;
  value?: string | object | Array<any> | number | boolean;
  role?: string;
  additionalProps?: object;
  disabled?: boolean;
  children?: any;
  iconName?: string;
  iconLeft?: boolean;
  hasHover?: boolean;
  hoverSpeed?: number;
  iconColor?: string;
  iconHoverColor?: string;
  iconSize?: number;
  active?: boolean;
  ariaPressed?: boolean;
}

export interface IndividualButtonSizes {
  fontSize: number;
  height: number;
  horizontalPadding: number;
  iconSize: number;
  iconPaddingTop: number;
}
interface ButtonSizeMap {
  sm: IndividualButtonSizes;
  md: IndividualButtonSizes;
  lg: IndividualButtonSizes;
  xl: IndividualButtonSizes;
}

// A map of the various sizes detailing various styling tweaks per size
export const buttonSizeMap: ButtonSizeMap = {
  sm: {
    fontSize: 13,
    height: 32,
    horizontalPadding: 10,
    iconSize: 14,
    iconPaddingTop: 1
  },
  md: {
    fontSize: 15,
    height: 36,
    horizontalPadding: 10,
    iconSize: 16,
    iconPaddingTop: 1
  },
  lg: {
    fontSize: 18,
    height: 42,
    horizontalPadding: 15,
    iconSize: 18,
    iconPaddingTop: 1
  },
  xl: {
    fontSize: 20,
    height: 48,
    horizontalPadding: 20,
    iconSize: 18,
    iconPaddingTop: 2
  }
};

export type ButtonRef = HTMLButtonElement;
